const normalizeText = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const getCatalogOccasionLabel = (occasion) => {
  const name = normalizeText(occasion?.name);
  const emoji = normalizeText(occasion?.emoji);

  return emoji ? `${emoji} ${name}` : name;
};

export const getCatalogOccasionOptions = (occasions) => {
  if (!Array.isArray(occasions)) {
    return [];
  }

  const occasionNames = new Set();

  return occasions.reduce((options, occasion) => {
    const name = normalizeText(occasion?.name);

    if (!name || occasionNames.has(name)) {
      return options;
    }

    occasionNames.add(name);

    return [
      ...options,
      {
        ...occasion,
        name,
        emoji: normalizeText(occasion?.emoji),
      },
    ];
  }, []);
};

export const CATEGORY_OPTIONS = [
  'Gastronomía y alimentos',
  'Decoración, Hogar y Jardín',
  'Deportes y actividades al aire libre',
  'Joyas y accesorios',
  'Mascotas',
  'Niñ@s e Infantes',
  'Salud y Belleza',
  'Servicios',
  'Vestuario y Calzado',
  'Otros',
];
